import React from 'react'

// חלון אישור לפני מימוש הטבה, באותו סגנון של הפופאפים הקיימים באפליקציה (PremiumPopup)
// loading: בזמן הקריאה לשרת הכפתורים נעולים כדי למנוע לחיצה כפולה
const BenefitConfirmPopup = ({ show, title, message, onConfirm, onClose, loading = false }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4" dir='rtl'>
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md relative animate-fadeIn p-6">

        {/* סגירה */}
        <button
          type="button"
          onClick={onClose}
          disabled={loading}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 disabled:opacity-40"
          aria-label="סגור"
        >
          ✕
        </button>

        {/* כותרת */}
        <h2 className="text-xl font-bold text-[#0d406b] text-center mb-3">
          {title}
        </h2>

        {/* תוכן */}
        <p className="text-gray-700 text-sm text-center leading-relaxed mb-5">
          {message}
        </p>

        {/* אישור */}
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading}
          className="w-full bg-[#0d406b] text-white py-2 rounded-lg font-semibold hover:bg-[#0b3558] transition shadow disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {loading ? "שולח" : "אישור"}
        </button>

        {/* ביטול */}
        <button
          type="button"
          onClick={onClose}
          disabled={loading}
          className="w-full text-gray-500 text-xs mt-3 underline disabled:opacity-40"
        >
          ביטול
        </button>

      </div>
    </div>
  );
}

export default BenefitConfirmPopup
